import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77ae14ae")

_pushScopeId("data-v-77ae14ae")
const _hoisted_1 = { class: "trend" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TrendItem = _resolveComponent("TrendItem")
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_van_tab, { title: "最近7天" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 7 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近1月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 30 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近3月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 90 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近6月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 180 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
})